import React, { useEffect, useRef, useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import AreaImage from "../../images/county-areas.png";
import ReactApexChart from "react-apexcharts";
import {
  AREA_INCH_OPTIONS_FOR_SEASONAL_AVERAGES,
  CROP_INCH_OPTIONS_FOR_SEASONAL_AVERAGES,
} from "../../configurations/Constants";

function AreaAverageGraph({
  areaInches,
  cornInches,
  soybeanInches,
  selectedYear,
}) {
  const [cropToggled, setCropToggled] = useState(false);
  const [series, setSeries] = useState([
    { name: "Area Average", data: areaInches },
  ]);
  const [options, setOptions] = useState(
    CROP_INCH_OPTIONS_FOR_SEASONAL_AVERAGES
  );
  const [chartWidth, setChartWidth] = useState("100%");
  const chartContainerRef = useRef(null);

  useEffect(() => {
    if (chartContainerRef.current) {
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          const newWidth = entry.contentRect.width;
          setChartWidth(newWidth);
        }
      });
      resizeObserver.observe(chartContainerRef.current);
    }
  }, []);

  useEffect(() => {
    if (cropToggled) {
      setSeries([
        { name: "Corn", data: cornInches },
        { name: "Soybean", data: soybeanInches },
      ]);
      setOptions(CROP_INCH_OPTIONS_FOR_SEASONAL_AVERAGES);
    } else {
      setSeries([{ name: "Area Average", data: areaInches }]);
      setOptions(AREA_INCH_OPTIONS_FOR_SEASONAL_AVERAGES);
    }
  }, [areaInches, cornInches, soybeanInches, cropToggled]);

  return (
    <div>
      <Row className="area-avg-body">
        <Col
          lg={4}
          className="d-flex justify-content-center align-items-center"
        >
          <img
            src={AreaImage}
            alt="footer-logo"
            className="area-avg-body-img"
          />
        </Col>
        <Col lg={8} className="area-avg-graph">
          <div
            className="d-flex justify-content-center gap-2"
            ref={chartContainerRef}
          >
            <span>Area Averages ({selectedYear.value})</span>
            <Form.Check
              key="crops-check"
              type="checkbox"
              name="crops-check"
              label="Corn / Soybean"
              checked={cropToggled}
              className="ms-3"
              onChange={() => setCropToggled(!cropToggled)}
            />
          </div>
          <ReactApexChart
            type="bar"
            width={chartWidth}
            height="100%"
            series={series}
            options={options}
          />
        </Col>
      </Row>
    </div>
  );
}

export default AreaAverageGraph;
